module.exports = {
    "dismiss": `Atmesti`
};


//# sourceMappingURL=lt-LT.main.js.map
